module.exports = __webpack_public_path__ + "media/assets/images/category/StarringYou@2x-db07a07707b700bc25a2cbc0b5a94268.png";